import $ from 'jquery';

export default function Reservation(vm) {
    this.all = function(params) {
        var url = '/reservation/list?' + $.param(params);

        return vm.get(url);
    };

    this.create = function(params) {
        var url = '/reservation/create';

        return vm.post(url, params);
    };

    this.status = function(params) {
        var url = '/reservation/status';

        return vm.post(url, params);
    };

    this.get = function(id) {
        var url = '/reservation/detail/' + id;

        return vm.get(url);
    };

    this.delete = function(params) {
        var url = null;

        if (params.is_permanent == 1)
            url = '/reservation/force-delete/' + params.id;
        else
            url = '/reservation/delete/' + params.id;

        return vm.delete(url);
    };

    this.restore = function(id) {
        var url = '/reservation/restore/' + id;

        return vm.get(url);
    };
}